import React from "react";
import { Link } from "react-router-dom";
import { Zap, CheckCircle, Lightbulb, Shield, Users } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Consulting = () => {
  return (
    <div className="font-sans min-h-screen bg-gray-50">
      <Header />

      {/* Hero Section */}
      <section className="relative min-h-[500px] flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url(/images/consulting/1503.jpg)" }}
        ></div>
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black to-flowkraft-primary opacity-90"></div>

        <div className="container mx-auto px-4 relative z-10 py-20">
          <div className="flex items-center justify-center mb-8">
            <Zap className="w-16 h-16 text-flowkraft-secondary" />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-center mb-6 text-white">
            Consulting & Stratégie
          </h1>
          <p className="text-xl text-center text-gray-200 max-w-3xl mx-auto">
            Accompagnement stratégique pour votre transformation digitale
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            Votre Partenaire Stratégique
          </h2>
          <p className="text-lg text-gray-700 mb-4">
            Nous vous accompagnons dans votre transformation digitale avec une
            approche pragmatique et orientée résultats. Notre expertise
            technique et stratégique vous aide à prendre les bonnes décisions
            pour votre business.
          </p>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            Nos Services de Consulting
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <Shield className="w-12 h-12 text-flowkraft-primary mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Audit Technique
              </h3>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Code review approfondie
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Analyse de performance
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Audit de sécurité
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <Lightbulb className="w-12 h-12 text-flowkraft-primary mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Conseil en Architecture
              </h3>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Architecture logicielle
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Choix technologiques
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Scalabilité & Cloud
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <Users className="w-12 h-12 text-flowkraft-primary mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Formation Équipes
              </h3>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Formations sur mesure
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Montée en compétences
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Coaching technique
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <Zap className="w-12 h-12 text-flowkraft-primary mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Optimisation Process
              </h3>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Méthodologie Agile
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  CI/CD & DevOps
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Best practices
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="relative py-20 overflow-hidden">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url(/images/main/2149755776.jpg)" }}
        ></div>
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-flowkraft-primary to-black opacity-90"></div>

        <div className="container mx-auto px-4 text-center relative z-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
            Accélérez votre transformation digitale
          </h2>
          <Link
            to="/#contact"
            className="inline-block bg-white text-flowkraft-primary px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors"
          >
            Discutons de vos besoins
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Consulting;
